export const DATABASE_TAB_IDS = ['institutions', 'assignments', 'leks'] as const;

export type DatabaseTabId = (typeof DATABASE_TAB_IDS)[number];

export const isDatabaseTabId = (value: unknown): value is DatabaseTabId =>
	typeof value === 'string' && (DATABASE_TAB_IDS as readonly string[]).includes(value);

/** A dropdown option. `value` is what gets sent to the API, `label` is what the user sees. */
export interface DatabaseFilterOption {
	value: string;
	label: string;
}

/** One successful dropdown result for a single source. `options` may be empty; that is still a success. */
export interface DatabaseOptionsEntry {
	fetchedAt: number;
	options: DatabaseFilterOption[];
}

export interface DatabaseSchemaEntry<TSchema> {
	view: string;
	schema: TSchema;
}
